import { MemberPage } from '@/features/setting/page/member-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/$workspaceId/settings/member')({
  component: MemberPage,
  beforeLoad(ctx) {
    return {
      workspaceId: ctx.params.workspaceId,
    };
  },
});
